import { render, staticRenderFns } from "./BearbeiteLand.vue?vue&type=template&id=2ae9a644&"
import script from "./BearbeiteLand.vue?vue&type=script&lang=js&"
export * from "./BearbeiteLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports